<script lang="ts">
import { AppSortBlockComponent } from "./sort-block";
export default AppSortBlockComponent;
</script>
<template>
    <div class="sort-block">
        <div
            class="select select--small search-bar--sort"
            style="display: flex; align-items: center"
        >
            <div
                class="select__label"
                :style="{
                    width: unsetFixedWidth ? undefined : '4.0625rem',
                    'align-items': 'center',
                    'text-transform': 'none',
                    'font-size': fontSize,
                }"
            >
                <i18n-t keypath="ourCars.sortBy" />
            </div>
            <app-dropdown
                v-model="sortModel"
                :fontSize="fontSize"
                type="single"
                :show-checkbox="false"
                :options="sortOptions"
                :get-value="(option) => option.configuration"
                :get-label="(option) => option.description"
                :placeholder="placeholder"
            ></app-dropdown>
        </div>
    </div>
</template>

<style lang="scss">
@media (max-width: 768px) {
    .sort-block {
        padding-left: 10%;
        width: 100%;
    }
}
</style>
